import { FormikValues } from "formik"
import { defaultDisclaimer, TemplateComponents } from "@blackpearlmail/cerberus"
import { encodeBase64 } from "../../modules/functions"

export function pipeDataToPreview(values: FormikValues) {
    const formattedData: { [key: string]: string | undefined } = {}

    Object.entries(values).forEach(([key, value]) => {
        if (["name", "orgname", "position", "workphone", "website"].includes(key)) {
            if (value !== undefined && value.trim() !== "") {
                formattedData[`default/${key}`] = value
            }
        }

        if (key === "profileimage") {
            formattedData[`default/${key}`] = value
        }
    })
    return formattedData
}

export function addDisclaimer(components: TemplateComponents[]) {
    const disclaimer = {
        ...defaultDisclaimer,
        content: `DISCLAIMER: Customize your disclaimer to share important legal notices, eco-friendly initiatives, or 
            show your personality.`,
        fontColour: "#333333",
        fontSize: 10,
    }

    components.splice(components.length - 1, 0, disclaimer)

    return components
}

export function nextLocation(compatible: boolean, source: string, values: FormikValues): string {
    const formData = {
        name: values.name,
        email: values.email,
        orgname: values.orgname,
    }
    if (source === "signup") {
        if (!compatible) {
            return `https://blackpearlmail.com/incompatible-email-hosting-provider/?bpm_fd=${encodeBase64(
                JSON.stringify(formData)
            )}`
        }
        return `/choose-plan?bpm_fd=${encodeBase64(JSON.stringify(formData))}`
    }

    if (source === "demo") {
        return "/book-a-demo-with-an-email-expert"
    }

    // Anyone not a signup is assumed to be requesting a demo
    return "/book-a-demo-with-an-email-expert"
}

export function getSubmissionTrackingString(value: "signup" | "demo") {
    switch (value) {
        case "signup":
            return "sign up"
        default:
            return value
    }
}
